import { Pipe, PipeTransform } from '@angular/core';
import { Bots } from 'src/app/features/models/list.model';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: Bots[], filterString: string, property: any): any[] {
    if (value.length === 0 || !filterString) {
      return value;
    }
    let filteredBotss: Bots[] = [];
    for (let bot of value) {
      // if (bot[property].toLowerCase().includes(filterString.toLowerCase())) {
      //   filteredBotss.push(bot);
      // }
    }
    return filteredBotss;
  }

}
